/* eslint-disable max-len */
import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'
import {
    WithId,
} from 'app/types/common.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    OrderSubType,
    ProductType,
} from 'app/enums/label.enums'

export type ContainerSelectionViewItem = WithId<number> & {
    orderNumber: string
    originAirportIataCode: string
    destinationAirportIataCode: string
    customerLocationName: string
    pricingAccountCompanyName: string
    originLocationLocationName: string
    handoverPointLocationName: string
    plannedPickup: string
    requiredContainers: string[],
    containerSelectionUntilUtc: string,
}

export type TransportViewItem = WithId<number> & {
    orderNumber: string
    originAirportIataCode: string
    destinationAirportIataCode: string
    orderSubType: string
    originLocationLocationName: string
    destinationLocationLocationName: string
    plannedPickup: string
    requiredContainers: string[],
    containerSelectionUntilUtc: string,
}
export type ContainerWrongPairingsViewItem = {
    serialNumber: string
    containerTypeContainerModel: string
    currentOrderOrderNumber: string
    lastMeasuredOnUtcInternal: string
    lastMeasuredOnUtcAmbient: string
    currentInternalLocationLocationName: string
    currentAmbientLocationLocationName: string
}

export const containerSelectionColumns: SkyDataGridColumnDefinition<ContainerSelectionViewItem>[] = [
    {
        name: 'orderNumber',
        filterField: 'orderNumber',
        filterType: FilterType.Array,
        labelKey: 'ORDER',
    },
    {
        name: 'originAirportIataCode',
        filterField: 'originAirportIataCode',
        filterType: FilterType.Array,
        labelKey: 'ORIGIN_AIRPORT',
    },
    {
        name: 'destinationAirportIataCode',
        filterField: 'destinationAirportIataCode',
        filterType: FilterType.Array,
        labelKey: 'DESTINATION_AIRPORT',
    },
    {
        name: 'customerLocationName',
        filterField: 'customerLocationName',
        filterType: FilterType.Array,
        labelKey: 'CUSTOMER',
    },
    {
        name: 'pricingAccountCompanyName',
        labelKey: 'PRICING_ACCOUNT',
        filterField: 'pricingAccountCompanyName',
        filterType: FilterType.Array,
    },
    {
        name: 'originLocationLocationName',
        filterField: 'originLocationLocationName',
        filterType: FilterType.Array,
        labelKey: 'ORIGIN_LOCATION',
    },
    {
        name: 'handoverPointLocationName',
        labelKey: 'HANDOVER_POINT',
        filterField: 'handoverPointLocationName',
        filterType: FilterType.Array,
    },
    {
        name: 'plannedPickup',
        labelKey: 'PLANNED_PICK_UP_ON',
        componentName: 'DateTimeCell',
        filterField: 'plannedPickup',
        filterType: FilterType.DateRange,
    },
    {
        name: 'requiredContainers',
        labelKey: 'REQUIRED_CONTAINERS',
        componentName: 'List',
        sorting: false,
    },
    {
        name: 'containerSelectionUntilUtc',
        labelKey: 'REMAINING_OVERDUE',
        componentName: 'ContainerSelectionUntil',
    },
]

export const internalTransportColumns: SkyDataGridColumnDefinition<TransportViewItem>[] = [
    {
        name: 'orderNumber',
        filterField: 'orderNumber',
        filterType: FilterType.Array,
        labelKey: 'ORDER',
    },
    {
        name: 'originAirportIataCode',
        filterField: 'originAirportIataCode',
        filterType: FilterType.Array,
        labelKey: 'ORIGIN_AIRPORT',
    },
    {
        name: 'destinationAirportIataCode',
        filterField: 'destinationAirportIataCode',
        filterType: FilterType.Array,
        labelKey: 'DESTINATION_AIRPORT',
    },
    {
        name: 'orderSubType',
        filterField: 'orderSubType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: OrderSubType,
        labelKey: 'ORDER_SUBTYPE',
    },
    {
        name: 'originLocationLocationName',
        filterField: 'originLocationLocationName',
        filterType: FilterType.Array,
        labelKey: 'ORIGIN_LOCATION',
    },
    {
        name: 'destinationLocationLocationName',
        filterField: 'destinationLocationLocationName',
        filterType: FilterType.Array,
        labelKey: 'DESTINATION_LOCATION',
    },
    {
        name: 'plannedPickup',
        filterField: 'plannedPickup',
        filterType: FilterType.DateRange,
        componentName: 'DateTimeCell',
        labelKey: 'PLANNED_PICK_UP_ON',
    },
    {
        name: 'requiredContainers',
        componentName: 'RequiredContainersList',
        allowedValuesEnum: ProductType,
        sorting: false,
        labelKey: 'REQUIRED_CONTAINERS',
    },
    {
        name: 'containerSelectionUntilUtc',
        componentName: 'ContainerSelectionUntil',
        labelKey: 'REMAINING_OVERDUE',
    },
]

export const containersWrongPairingsColumns: SkyDataGridColumnDefinition<ContainerWrongPairingsViewItem>[] = [
    {
        name: 'serialNumber',
        labelKey: 'SERIAL_NUMBER',
    },
    {
        name: 'containerTypeContainerModel',
        labelKey: 'CONTAINER_MODEL',
    },
    {
        name: 'currentOrderOrderNumber',
        labelKey: 'CURRENT_ORDER',
    },
    {
        name: 'lastMeasuredOnUtcInternal',
        componentName: 'Age',
        sorting: false,
        labelKey: 'INTERNAL_DATA_AGE',
    },
    {
        name: 'lastMeasuredOnUtcAmbient',
        componentName: 'Age',
        sorting: false,
        labelKey: 'AMBIENT_DATA_AGE',
    },
    {
        name: 'currentInternalLocationLocationName',
        labelKey: 'INTERNAL_LOGGER_LOCATION',
    },
    {
        name: 'currentAmbientLocationLocationName',
        labelKey: 'AMBIENT_LOGGER_LOCATION',
    },
]
